import React, { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  const reduced = useReducedMotion();
  if (reduced) {
    return <div className={className} data-id="element-696" data-mp="3ggyxayt8y50w">{children}</div>;
  }
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.28,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-697" data-mp="3gijsmqndxrzt">
      {children}
    </motion.div>;
}